import { AppBar, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SplitButton,
	SubmitButton,
} from "@websential/cosmic-v20";

import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";

// import { SplitButton } from "./SplitButton";

export interface IPayrollSetupToolbar {
	payrollScreenPermissions: any;
	onSubmitButtonClickedHandler: () => void;
	onCalculatePayrollClicked: () => void;
	onInsertButtonClicked: (selectedItem: any) => void;
	onDeleteEmployeePayrollDataClicked: () => void;
	haveCalculatedTable: boolean;
	payrollTableData: any;
	clientBankDDL: any;
	openRollbackDialogue?: any;
	gridsMaxTotalWidth?: any
}

export const PayrollSetupToolbar: FC<IPayrollSetupToolbar> = ({
	onSubmitButtonClickedHandler,
	onCalculatePayrollClicked,
	onInsertButtonClicked,
	onDeleteEmployeePayrollDataClicked,
	haveCalculatedTable,
	payrollTableData,
	clientBankDDL,
	payrollScreenPermissions,
	openRollbackDialogue,
	gridsMaxTotalWidth
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;
	return (
		<div style={{ width: gridsMaxTotalWidth && gridsMaxTotalWidth !== 0 ? `${gridsMaxTotalWidth}px` : "100%", minWidth: gridsMaxTotalWidth && gridsMaxTotalWidth !== 0 ? `${gridsMaxTotalWidth}px` : "100%", backgroundColor: "#fff", }}>
			<div
				style={{
					position: "sticky",
					left: !mobileTabOrSmallLaptopScreen ? 250 : 0,
					width: "fit-content",
					// zIndex: 5,
					backgroundColor: "#fff",
				}}
			>
				<AppBar
					position="sticky"
					color="default"
					elevation={1}
					data-testId={""}
					sx={{
						backgroundColor: "#fff",
						// // marginTop: theme.spacing(3),
						boxShadow: "none",
						alignItems: "center",
						zIndex: 0,
						// position: "sticky",
						// bottom: 0,
						// top: 'auto',
						// bottom: 0,
						// backgroundColor: '#fff',
						// boxShadow: 'none',
						// alignItems: 'center',
						// zIndex: (theme) => theme.zIndex.drawer + 1, // ensure above other elements

						paddingBottom: haveCalculatedTable ? "5rem" : ".5rem"
					}}
				>
					<Toolbar>
						<EnhancedButtonPrimeReact
							label="Save"
							// type="submit"
							onClickHandler={onSubmitButtonClickedHandler}
							// icon="pi pi-check"
							raised
							severity={EnhancedButtonPrimeReactSeverity.Success}
							style={{ marginRight: "1rem" }}
						/>
						<SplitButton
							options={["Insert Gross Hours", "Insert Gross", "Insert Hours", "Insert Previous", "Insert EDR"]}
							onClickHandler={onInsertButtonClicked}
							testId="t4-print-button"
						// icon={"pi pi-sign-in"}
						// listItemsLabel={`Print T4 Slips `}

						/>
						<EnhancedButtonPrimeReact
							// icon="pi pi-trash"
							label="Delete"
							raised
							onClickHandler={onDeleteEmployeePayrollDataClicked}
							style={{ marginLeft: "1rem" }}
							severity={EnhancedButtonPrimeReactSeverity.Danger}
						/>
						{payrollScreenPermissions && payrollScreenPermissions["Calculate Payroll"] && payrollScreenPermissions["Calculate Payroll"] ? <EnhancedButtonPrimeReact
							// icon="pi pi-plus"
							label="Calculate Payroll"
							raised
							onClickHandler={onCalculatePayrollClicked}
							style={{ marginLeft: "1rem" }}
							// severity={EnhancedButtonPrimeReactSeverity.Secondary}
							disabled={
								!openRollbackDialogue && (payrollTableData && payrollTableData.items.some((item: any) => item.salaryProfileMessage !== null)) ||
								!openRollbackDialogue && (payrollTableData && payrollTableData.items.some((item: any) => !item.td1Fed)) ||
								!openRollbackDialogue && (payrollTableData && payrollTableData.items.some((item: any) => !item.td1Prov))
								// (
								// 	clientBankDDL?.client_details_for_payroll?.paymentSetup === 200 &&
								// 	clientBankDDL?.client_bank_ddl?.some((bank: any) => bank.status !== 100)
								// )
								// || (
								// 	clientBankDDL?.client_details_for_payroll?.paymentSetup === 200 &&
								// 	clientBankDDL?.client_bank_ddl.length === 0
								// )
							}
						/> : <></>}
					</Toolbar>
				</AppBar></div></div>
	);
};
